import React from 'react';
import { DateInput, CommonDateInputProps } from 'framework/form';
import { CPDateIcon } from 'framework/ui/mui-builder';

const CurrentlyPlannedDateInput = (props: CommonDateInputProps) => {
  return (
    <DateInput
      {...props}
      dateIcon={
        <CPDateIcon
          sx={{
            marginRight: '10px',
            fontSize: '1.2rem',
            position: 'absolute',
            zIndex: 1,
            left: '10px',
            top: '8px',
            opacity: '0.8',
          }}
        />
      }
    />
  );
};
export default CurrentlyPlannedDateInput;
